/*
 * @Author: zhang lin
 * @Date: 2022-04-08 13:09:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-31 16:32:42
 * @Description: file content
 */

import React, { forwardRef, useImperativeHandle, useEffect, useState } from 'react';

import styles from './index.less';
import { Form, Input, Select, Radio } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form';
import { useIntl } from 'react-intl';
import messages from 'root/pages/InstallSupos/messages';
import { getDatabseListApi } from 'root/services/manager';

const { Option } = Select;
interface FCFormProps extends FormComponentProps {
  onSubmit: () => void;
  supOSConfigData: { [key: string]: any }; // 表单数据
  failMes?: string; // 连接数据库失败信息
}
const versionList = [
  {
    name: '11g_r2',
    value: 'default',
  },
  {
    name: '12c_r1',
    value: '12c_r1',
  },
  {
    name: '12c_r2',
    value: '12c_r2',
  },
  {
    name: '19c',
    value: '19c',
  },
];
const Database = forwardRef<FormComponentProps, FCFormProps>((props, ref) => {
  const intl = useIntl();
  const { form, supOSConfigData, failMes } = props;
  const [databaseList, setDatabaseList] = useState<any>([]);
  const [version, setVersion] = useState<any>([]);

  useImperativeHandle(ref, () => ({
    form,
  }));
  const { getFieldDecorator } = form;

  // 获取缓存数据
  let { database } = supOSConfigData;

  if (!database) database = { defaultDatabase: 0 };

  useEffect(() => {
    getDataBaseList(database.defaultDatabase === 0 ? 'all' : database.defaultDatabase === 1 ? 'ext' : 'rds');
  }, []);

  // 切换数据库类型
  const handleChange = (val: string) => {
    const str = databaseList?.find((item: any) => item.name === val)?.port;
    form.setFieldsValue({ port: str });

    // 切换的时候判断该项有没有version
    const result = databaseList?.find((item: any) => item.name === val)?.versions;
    setVersion(result);
  };

  // 切换部署数据库方式
  const databaseTypeChange = (el: any) => {
    const type = el.target.value === 0 ? 'all' : el.target.value === 1 ? 'ext' : 'rds';
    getDataBaseList(type).then((dblist: any) => {
      form.setFieldsValue({ type: dblist[0].name });
      form.setFieldsValue({ host: '' });
      form.setFieldsValue({ port: dblist[0].port });
      form.setFieldsValue({ oracleVersion: '' });
      form.setFieldsValue({ name: '' });
      form.setFieldsValue({ user: '' });
      form.setFieldsValue({ password: '' });
    });
    setVersion([]);
  };

  const getDataBaseList = async (type: string) => {
    let databaseList = null;
    await getDatabseListApi(type).then((res) => {
      const { data } = res;
      setDatabaseList(data);
      databaseList = data;
    });
    return databaseList;
  };

  const installConfig = () => {
    return (
      <Form labelCol={{ span: 5 }} wrapperCol={{ span: 17 }}>
        <Form.Item label={intl.formatMessage(messages.databaseType)} colon={false}>
          {getFieldDecorator('defaultDatabase', {
            initialValue: database['defaultDatabase'] || 0,
          })(
            <Radio.Group onChange={databaseTypeChange}>
              <Radio value={0}>{intl.formatMessage(messages.defaultDatabase)}</Radio>
              <Radio value={1}>{intl.formatMessage(messages.externalDatabase)}</Radio>
              <Radio value={2}>{intl.formatMessage(messages.allExternalDatabase)}</Radio>
            </Radio.Group>,
          )}
        </Form.Item>

        {form.getFieldValue('defaultDatabase') !== 0 && (
          <>
            <Form.Item label={intl.formatMessage(messages.type)} colon={false}>
              {getFieldDecorator('type', {
                initialValue: databaseList?.find((item: any) => item.name === database.type)?.name,
              })(
                <Select onChange={handleChange}>
                  {databaseList.map((item: any) => {
                    return (
                      <Option key={item.name} value={item.name}>
                        {item.displayName}
                      </Option>
                    );
                  })}
                </Select>,
              )}
              {/* <span className={styles.tip}>{intl.formatMessage(messages.supPlantTip)}</span> */}
            </Form.Item>
            {form.getFieldValue('type')?.toLowerCase() === 'oracle' ? (
              <Form.Item label={intl.formatMessage(messages.oracleVersion)} colon={false}>
                {getFieldDecorator('oracleVersion', { initialValue: versionList[0].name })(
                  <Select>
                    {versionList.map((item) => {
                      return (
                        <Option key={item.name} value={item.value}>
                          {item.name}
                        </Option>
                      );
                    })}
                  </Select>,
                )}
              </Form.Item>
            ) : null}

            {version?.length ? (
              <Form.Item label={intl.formatMessage(messages.version)} colon={false}>
                {getFieldDecorator('version', { initialValue: version[0] })(
                  <Select>
                    {version.map((item: string) => {
                      return (
                        <Option key={item} value={item}>
                          {item}
                        </Option>
                      );
                    })}
                  </Select>,
                )}
              </Form.Item>
            ) : null}

            <Form.Item label={intl.formatMessage(messages.address)} colon={false}>
              {getFieldDecorator('host', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.addressNull),
                  },
                  {
                    validator: async (rule: any, value: string, callback: () => void) => {
                      if (!value) return callback();
                      const flagIp =
                        /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
                      if (flagIp.test(value)) {
                        return callback();
                      } else {
                        throw new Error(intl.formatMessage(messages.addressError));
                      }
                    },
                  },
                ],
                initialValue: database['host'],
              })(<Input maxLength="64" />)}
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.port)} colon={false}>
              {getFieldDecorator('port', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.portNull),
                  },
                  {
                    message: intl.formatMessage(messages.portError),
                    pattern: new RegExp(
                      /^([1-9](\d{0,3}))$|^([1-5]\d{4})$|^(6[0-4]\d{3})$|^(65[0-4]\d{2})$|^(655[0-2]\d)$|^(6553[0-5])$/,
                    ),
                  },
                ],
                initialValue: database['port'] || '1521',
              })(<Input maxLength="64" />)}
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.databaseName)} colon={false}>
              {getFieldDecorator('name', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.databaseNameNull),
                  },
                ],
                initialValue: database['name'],
              })(<Input maxLength="64" />)}
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.username)} colon={false}>
              {getFieldDecorator('user', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.usernameNull),
                  },
                ],
                initialValue: database['user'],
              })(<Input autoComplete="off" maxLength="64" />)}
            </Form.Item>
            <Form.Item label={intl.formatMessage(messages.password)} colon={false}>
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: intl.formatMessage(messages.passwordNull),
                  },
                ],
                initialValue: database['password'],
              })(<Input.Password autoComplete="new-password" maxLength="64" />)}
            </Form.Item>
            {failMes ? (
              <span className={styles.failed}>
                {intl.formatMessage(messages.linkFail)}：{failMes}
              </span>
            ) : null}
          </>
        )}
      </Form>
    );
  };
  return <div className={styles.installConfig}>{installConfig()}</div>;
});
export default Form.create()(Database);
